export const NETWORK = "testnet";
export const NATIVE_DECIMALS = 24;

export const HELLO_NEAR_ADDRESS = "dev-1666191057769-59817066669753";
export const STAKING_ADDRESS = "dev-1666191057769-59817066669753";
export const PLATFORM_ADDRESS = "platform-test45.launchpad-deployer.testnet";
export const LAUNCHPAD_FACTORY_ADDRESS =
  "factory-test57.launchpad-deployer.testnet";
